import { CheckerboardPlusIcon } from './CheckerboardPlusIcon';

/**
 * author: Michael Irigoyen
 * id 020A5F88-EE7B-4FE7-ADC7-999A0ADB16EE
 * name checkerboard-plus
 * version: 4.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/checkerboard-plus.svg
 * tags
 * - Geographic Information System 
 */
export const RasterPlusIcon = CheckerboardPlusIcon;
export default RasterPlusIcon